/* eslint-disable camelcase */
import getCart from './getCart';
import updateCartCount from './updateCartCount';

const addToCart = async (variantId, qty, sellingPlan, properties) => {
  const item = {
    id: variantId,
    quantity: qty
  };

  if (sellingPlan) {
    item.selling_plan = sellingPlan;
  }

  if (properties && Object.keys(properties).length > 0) {
    item.properties = properties;
  }

  const items = { items: [item] };

  try {
    const atc = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items)
    });

    if (!atc.ok) {
      const error = await atc.json();
      throw new Error(error.description || 'Failed to add item to basket');
    }

    const addedItem = await atc.json();
    const cart = await getCart();

    updateCartCount(cart.item_count);
    return addedItem;
  } catch (err) {
    console.error('Add to cart error:', err);
    throw err;
  }
};

export default addToCart;
